module.exports = __webpack_public_path__ + "img/03.117778a4.png";